import { observable, action, makeObservable } from 'mobx';

type Themes = 'light' | 'dark';

export class LayoutStore {
  collapsed = false;
  theme: Themes = 'dark';
  showAlert = false;
  layoutLoading = false;
  loadingMessage = '';
  pgid = '';

  constructor() {
    const themesCache = 'dark';
    this.theme = themesCache as Themes;
    makeObservable(this, {
      collapsed: observable,
      theme: observable,
      showAlert: observable,
      setCollapsed: action,
      setTheme: action,
      setShowAlert: action,
      layoutLoading: observable,
      loadingMessage: observable,
      pgid: observable,
    });
  }

  setCollapsed = (isCollaPsed: boolean) => {
    this.collapsed = isCollaPsed;
  };

  setShowAlert = (showAlert: boolean) => {
    this.showAlert = showAlert;
  };

  setTheme = () => {
    const changeTmeme = this.theme === 'dark' ? 'light' : 'dark';
    this.theme = changeTmeme;
    localStorage.setItem('rdeliveryTheme', changeTmeme);
  };

  // 设置loading
  setLoading = (loading: boolean, message = '') => {
    this.layoutLoading = loading;
    this.loadingMessage = message;
  };

  setPgId = (pgid: string) => {
    this.pgid = pgid;
  };
}
